import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Chip from "@mui/material/Chip";
import { green, red } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { type Port } from "../../../types/port";

type Props = {
  port?: Port;
};

export const PortStatus = ({ port }: Props) => {
  const isDeleted = port?.isDeleted;
  const isDefined = port !== undefined;
  const { palette } = useTheme();
  const isDark = palette.mode === "dark";

  const statusColor = isDeleted
    ? isDark
      ? red[200]
      : red[800]
    : isDark
    ? green[200]
    : green[800];

  const iconColor = isDeleted
    ? isDark
      ? red[200]
      : red[600]
    : isDark
    ? green[200]
    : green[600];

  const Icon = isDeleted ? BlockOutlinedIcon : CheckCircleIcon;

  return (
    <Chip
      label={isDefined ? (isDeleted ? "Deleted" : "Active") : ""}
      icon={isDefined ? <Icon sx={{ fill: iconColor }} /> : undefined}
      sx={{
        borderColor: isDefined ? statusColor : undefined,
        color: isDefined ? statusColor : undefined,
      }}
      variant="outlined"
      size="small"
    />
  );
};
